import Vue from 'vue';
import {
    Button,
    ButtonGroup,
    Input,
    Radio,
    RadioButton,
    RadioGroup,
    Form,
    FormItem,
    Table,
    TableColumn,
    Tooltip,
    Popover,
    Scrollbar,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    Badge,
    Container,
    Menu,
    MenuItem,
    Image,
    Link,
    Tabs,
    TabPane,
    Dialog,
    Drawer,
    Header,
    Footer,
    Pagination,
    Select,
    Option,
    Checkbox
} from '@isyscore/base-ui';

[
    Button,
    ButtonGroup,
    Input,
    Radio,
    RadioButton,
    RadioGroup,
    Form,
    FormItem,
    Table,
    TableColumn,
    Tooltip,
    Popover,
    Scrollbar,
    Dropdown,
    DropdownItem,
    DropdownMenu,
    Badge,
    Container,
    Menu,
    MenuItem,
    Image,
    Link,
    Tabs,
    TabPane,
    Dialog,
    Drawer,
    Header,
    Footer,
    Pagination,
    Select,
    Option,
    Checkbox
].forEach((comp) => {
    Vue.use(comp);
});
